import { AllowedMarkChannels, EncField, MarkChannel, MarkType } from '@mode-vegas/vegas';

export interface ChannelSummary {
  channel: MarkChannel;
  type: 'field' | 'multiple' | 'empty';
  field: EncField | undefined;
  id: string | undefined;
  fieldIds: string[];
  isValid: boolean;
}

export const IconMarkMap: Record<MarkType, string> = {
  Area: 'icon-chart-area',
  Bar: 'icon-chart-bar-vert',
  Circle: 'icon-mark-circle',
  Donut: 'icon-chart-donut',
  Line: 'icon-chart-line',
  Pie: 'icon-chart-pie',
  Shape: 'icon-star-unfilled',
  Text: 'icon-mark-label',
  Square: 'icon-warning', // Not supported
  TotalArea: 'icon-warning', // Not supported
  Map: 'icon-warning', // Not supported
};

export const IconWarning = 'icon-warning';

export const IconChannelMap: Record<MarkChannel, string> = {
  angle: 'icon-mark-angle',
  baseline: 'icon-baseline',
  color: 'illo-mini-mark-color',
  detail: 'icon-mark-detail',
  label: 'icon-warning', // Not supported
  size: 'icon-mark-size',
  text: 'icon-mark-label',
  tooltip: 'icon-warning', // Not supported
};

export function makeEmptyChannelSummary(channel: MarkChannel): ChannelSummary {
  return {
    channel,
    type: 'empty',
    isValid: true,
    field: undefined,
    fieldIds: [],
    id: undefined,
  };
}

export function markChannelIdsKey(m: MarkChannel) {
  switch (m) {
    case 'angle':
      return 'angleIds';
    case 'color':
      return 'colorIds';
    case 'detail':
      return 'detailIds';
    case 'label':
      return 'labelIds';
    case 'size':
      return 'sizeIds';
    case 'text':
      return 'textIds';
    case 'tooltip':
      return 'tooltipIds';
    case 'baseline':
      return 'baselineIds';
  }
}

export function getAllowedMarkChannels(excluded: Array<MarkChannel> = []) {
  return Object.entries(AllowedMarkChannels).reduce(
    (allowed, [markType, channels]) => {
      allowed[markType as MarkType] = channels.filter((channel: MarkChannel) => !excluded.includes(channel));
      return allowed;
    },
    { ...AllowedMarkChannels }
  );
}
